export default __webpack_public_path__ + "static/media/442.64fe9d92.png";